export class ServiceTypeAttributeTemplateEdit {
  defaultValue: string | null;
  isRequired: boolean;
  isPrintable: boolean;
  constructor() {
    this.defaultValue = "";
    this.isRequired = false;
    this.isPrintable = false;
  }
}
